<template>
  <v-app>
    <v-main>
      <snackbar/>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import store from './common/store';
import snackbar from './components/snackbar/snackbar.vue';

export default {
  name: 'App',

  components: {
    snackbar,
  },

  methods: {
    setTheme() {
      let themeParam = this.$route.query.theme;
      if (!themeParam) {
        const theme = store.getTheme();
        themeParam = theme || 'light';
      }
      store.saveTheme(themeParam);
      this.$themes.applyTheme(themeParam);
    },
  },
  async beforeCreate() {
    const {
      token,
      driveCredentialCode = null,
      hasNotificationConfigAuthority = null,
      hasMenu = null,
    } = this.$route.query;

    const accessTokenFromQuery = token != null && String(token) !== 'undefined' && String(token) !== 'null'
      ? token
      : null;
    if (accessTokenFromQuery) {
      store.saveToken(accessTokenFromQuery);
    } else {
      store.removeToken();
    }
    store.saveDriveCredentialCode(driveCredentialCode);
    store.saveHasNotificationConfigAuthority(hasNotificationConfigAuthority);
    store.saveHasMenu(hasMenu);
  },

  created() {
    this.setTheme();
  },
};
</script>
